export type FaixaLitragem = {
	id: string;
	label: string;
	min: number;
	max: number;
};

export const FAIXAS_LITRAGEM: FaixaLitragem[] = [
	{ id: "0-5000", label: "0 – 5.000", min: 0, max: 5000 },
	{ id: "5001-10000", label: "5.001 – 10.000", min: 5001, max: 10000 },
	{ id: "10001-15000", label: "10.001 – 15.000", min: 10001, max: 15000 },
	{ id: "15001-20000", label: "15.001 – 20.000", min: 15001, max: 20000 },
	{ id: "20001-25000", label: "20.001 – 25.000", min: 20001, max: 25000 },
	{ id: "25001-30000", label: "25.001 – 30.000", min: 25001, max: 30000 },
	{ id: "30001-35000", label: "30.001 – 35.000", min: 30001, max: 35000 },
	{ id: "35001-40000", label: "35.001 – 40.000", min: 35001, max: 40000 },
	{ id: "40001-45000", label: "40.001 – 45.000", min: 40001, max: 45000 },
	{ id: "45001-50000", label: "45.001 – 50.000", min: 45001, max: 50000 },
	{ id: "50001-55000", label: "50.001 – 55.000", min: 50001, max: 55000 },
	{ id: "55001-60000", label: "55.001 – 60.000", min: 55001, max: 60000 },
	{
		id: "60001+",
		label: "60.001 pra cima",
		min: 60001,
		max: Number.POSITIVE_INFINITY,
	},
];

export function getFaixaByVolume(volume: number): FaixaLitragem | undefined {
	return FAIXAS_LITRAGEM.find((faixa) => volume >= faixa.min && volume <= faixa.max);
}
